import type { IconSvgObject } from './types';

const CornerLeftUpIcon: IconSvgObject = [
  ["path", { d: "M9 5.00195L9 12.002C9 15.7732 9 17.6588 10.1716 18.8304C11.3431 20.002 13.2288 20.002 17 20.002L20 20.002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 9.00191C4 9.00191 7.68244 4.00196 9.00004 4.00195C10.3176 4.00194 14 9.00195 14 9.00195", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CornerLeftUpIcon;
